import { Auth0Client } from '@auth0/auth0-spa-js';
import {
  postAccountIntegrateExecuteWithExistingAccount,
  postAccountIntegratePreserveAuthorization,
} from '../../api/apiClient';
import { isHighschoolEmail } from '../highschool';

const integrationAppAuth0Client = new Auth0Client({
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_INTEGRATION_APP_AUTH0_CLIENT_ID,
  authorizationParams: {
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    scope: 'openid profile',
  },
});

export async function signInToIntegrationApp({
  screenHint,
  loginHint,
}: { screenHint?: string; loginHint?: string } = {}): Promise<void> {
  const { response } = await postAccountIntegratePreserveAuthorization();
  if (!response.ok) {
    throw new Error('認証エラー');
  }

  await integrationAppAuth0Client.loginWithRedirect({
    authorizationParams: {
      redirect_uri: `${window.location.origin}/integration/callback`,
      screen_hint: screenHint,
      login_hint: loginHint,
      prompt: 'login',
    },
  });
}

/**
 * 再ログイン後のユーザと、再ログイン前に保存したユーザ情報を用いて統合を実行する。
 * 再ログイン前のユーザの情報は http only cookie のため、実際にリクエストを送ったうえで確認する
 */
export async function integrateWithPreservedAuthorization(): Promise<{ status: number }> {
  // AuthProvider の外で実行する必要がある
  await integrationAppAuth0Client.handleRedirectCallback();
  const user = await integrationAppAuth0Client.getUser();

  // handleCallback が正しく認証されれば user は存在する (キャッシュではない)
  if (!user) {
    return { status: 403 };
  }

  if (!isHighschoolEmail(user.email)) {
    return { status: 403 };
  }

  const { response } = await postAccountIntegrateExecuteWithExistingAccount();

  return { status: response.status };
}
